/*********************
 * Mobillor Technologies Pvt. ltd. CONFIDENTIAL
 * __________________
 *
 *  Mobillor Technologies Pvt. Ltd.
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Mobillor Technologies Pvt. Ltd.
 * The intellectual and technical concepts contained
 * herein are proprietary to Mobillor Technologies Pvt. Ltd.
 * may be covered by Rebublic Of India and Foreign Patents,
 * patents in process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Mobillor Technologies Pvt. Ltd.
 */

import axios from "axios";
import Config from "../../../config/index";
import {
  GET_USER_DETAILS_FOR_ADMIN_FAILURE,
  GET_USER_DETAILS_FOR_ADMIN_REQUEST,
  GET_USER_DETAILS_FOR_ADMIN_SUCCESS,
} from "./userAdminDetailsTypes";
let userManagementUrl = Config.userManagementUrl;
const getUserDetailsForAdminRequest = () => {
  return {
    type: GET_USER_DETAILS_FOR_ADMIN_REQUEST,
  };
};

const getUserDetailsForAdminSuccess = (payload) => {
  return {
    type: GET_USER_DETAILS_FOR_ADMIN_SUCCESS,
    payload: payload,
  };
};

const getUserDetailsForAdminFaliure = (error) => {
  return {
    type: GET_USER_DETAILS_FOR_ADMIN_FAILURE,
    payload: error,
  };
};

const getUserDetailsForAdmin = (clientId, jwtToken) => {
  let headers = {
    headers: {
      Authorization: `Bearer ${jwtToken}`,
    },
  };
  return (dispatch) => {
    dispatch(getUserDetailsForAdminRequest());
    let url = `${userManagementUrl}/user/get?clientId=${clientId}`;
    return axios
      .get(url, headers)
      .then((response) => {
        dispatch(getUserDetailsForAdminSuccess(response.data));
        return response.data;
      })
      .catch((err) => {
        dispatch(getUserDetailsForAdminFaliure(err.message));
        return { status: false, data: err.message };
      });
  };
  // return (dispatch) => {
  //   dispatch(getSubModuleForCreateRoleRequest());
  //   let url = `${userManagementUrl}/roles/get_actions_for_role_creation`;
  //   return axios
  //     .post(url, payload, headers)
  //     .then((response) => {
  //       dispatch(getSubModuleForCreateRoleSuccess(response.data));
  //       return { status: true, data: response.data };
  //     })
  //     .catch((err) => {
  //       dispatch(getSubModuleForCreateRoleFaliure(err.response));
  //       return { status: false, data: err.response };
  //     });
  // };
};

export { getUserDetailsForAdmin };
